import React from "react";
import { IoCheckmarkCircle } from "react-icons/io5";
import { configsService } from "../../Services/configs.service";
import { extractEmailText } from "../ReportConfig/vehicleGroupReportConfig.utils";

export default function EmailConfigManager({
  reportKey,
  vehicleGroupId,
  reportTypes,
  emailsByReport,
  setEmailsByReport,
  loadingButtons,
  setLoadingButtons,
  fetchEmails,
}) {
  const { email, list, error } = emailsByReport[reportKey] || {
    email: "",
    list: [],
    error: "",
  };

  React.useEffect(() => {
    if (vehicleGroupId && reportKey && fetchEmails) {
      fetchEmails(reportKey);
    }
  }, [vehicleGroupId, reportKey, fetchEmails]);

  const handleChange = (e) => {
    setEmailsByReport((prev) => ({
      ...prev,
      [reportKey]: { ...prev[reportKey], email: e.target.value },
    }));
  };

  const handleAdd = async (emailFromList = "") => {
    const trimmedEmail = extractEmailText(emailFromList || email || "").trim();
    const isResend = Boolean(emailFromList);
    if (!trimmedEmail) return;

    if (!isResend && list.some((e) => e.email === trimmedEmail)) {
      setEmailsByReport((prev) => ({
        ...prev,
        [reportKey]: {
          ...prev[reportKey],
          error: "Este email já foi adicionado.",
        },
      }));
      return;
    }

    setLoadingButtons((prev) => ({ ...prev, [reportKey]: true }));

    try {
      const reportTypeObj = reportTypes.find((t) => t.key === reportKey);
      if (!reportTypeObj) {
        console.error(`Report key "${reportKey}" não encontrado.`);
        return;
      }

      const payload = {
        vehicleGroupId,
        codeReport: reportTypeObj.codeReport,
        email: trimmedEmail,
      };

      const created = await configsService.createEmailConfiguration(payload);

      if (!created || created.error) {
        throw new Error("Falha ao adicionar e-mail");
      }

      await fetchEmails(reportKey);

      setEmailsByReport((prev) => ({
        ...prev,
        [reportKey]: {
          ...prev[reportKey],
          email: "",
          error: "",
        },
      }));
    } catch (err) {
      console.error("Erro ao adicionar email:", err);
      setEmailsByReport((prev) => ({
        ...prev,
        [reportKey]: {
          ...prev[reportKey],
          error: "Falha ao adicionar e-mail. Tente novamente.",
        },
      }));
    } finally {
      setLoadingButtons((prev) => ({ ...prev, [reportKey]: false }));
    }
  };

  const handleRemove = async (vehicleGroupEmailId) => {
    try {
      const removed = await configsService.deleteEmailConfiguration(vehicleGroupEmailId);

      if (removed && removed.error) {
        throw new Error("Falha ao remover e-mail");
      }

      setEmailsByReport((prev) => ({
        ...prev,
        [reportKey]: {
          ...prev[reportKey],
          list: prev[reportKey].list.filter(
            (entry) => entry.id !== vehicleGroupEmailId
          ),
        },
      }));
    } catch (err) {
      console.error("Erro ao remover email:", err);
    }
  };

  return (
    <div className="row" style={{ marginBottom: 20 }}>
      <div className="col-md-6">
        <div className="input-group mb-2">
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={handleChange}
            placeholder="Digite o e-mail"
          />
          <button
            className="btn btn-primary"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              handleAdd();
            }}
            disabled={loadingButtons[reportKey]}
          >
            {loadingButtons[reportKey] ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Inserindo...
              </>
            ) : (
              "Inserir"
            )}
          </button>
        </div>
        <span style={{ color: "red", fontSize: 10 }}>{error}</span>

        <ul className="list-group">
          {list.length === 0 ? (
            <li className="list-group-item text-muted" style={{ fontSize: 10 }}>
              Nenhum e-mail cadastrado.
            </li>
          ) : (
            list.map((entry) => {
              const isValidated = entry.isValid === "S";
              return (
                <li
                  key={entry.id}
                  className="list-group-item d-flex align-items-center"
                  style={{ gap: "16px" }}
                >
                  <span
                    style={{
                      flex: 1,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {entry.email}
                  </span>

                  {/* Validated: show bold green tick only */}
                  {isValidated ? (
                    <IoCheckmarkCircle
                      style={{ color: "#198754", fontSize: 17, flexShrink: 0 }}
                      title="E-mail validado"
                    />
                  ) : (
                    /* Not validated: show Pendente badge + Reenviar only */
                    <>
                      <span className="badge bg-warning text-dark" style={{ flexShrink: 0 }}>
                        Pendente
                      </span>
                      <button
                        className="btn btn-sm btn-outline-info"
                        type="button"
                        style={{ flexShrink: 0 }}
                        onClick={(e) => {
                          e.preventDefault();
                          handleAdd(entry.email);
                        }}
                      >
                        Reenviar
                      </button>
                    </>
                  )}

                  <button
                    className="btn btn-sm btn-outline-danger"
                    type="button"
                    style={{ flexShrink: 0 }}
                    onClick={(e) => {
                      e.preventDefault();
                      handleRemove(entry.id);
                    }}
                  >
                    Excluir
                  </button>
                </li>
              );
            })
          )}
        </ul>
      </div>
    </div>
  );
}
